import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authcustomer',
  templateUrl: './authcustomer.component.html',
  styleUrls: ['./authcustomer.component.css']
})
export class AuthcustomerComponent implements OnInit {
 
  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }



  requestData =`

  {
    "username": "test@crunchmediaworks.com",
    "password": "XXXXXXX"
  }

  `



  sucessData =`
  "data": {
    "AuthenticationResult": {
      "AccessToken": "XX",
      "ExpiresIn": 3600,
      "IdToken": "YY",
      "NewDeviceMetadata": {
        "DeviceGroupKey": "-oeHL8RDA",
        "DeviceKey": “ZZ”
      },
      "RefreshToken": "XYZ”,
      "TokenType": "Bearer"
    },
    "ChallengeName": null,
    "ChallengeParameters": {},
    "Session": null
  },
  "message": "Authenticated successfully"
}
  `
  Error5x =`
  {
    "error": {},
    "message": "string"
  }
  `

  Error4x =`
  {
    "error": "NotAuthorizedException: Incorrect username or password.",
    "message": "Error authenticating user"
  }
  
  `
  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


}
